import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An arbitrary precision signed decimal */
  BigDecimal: { input: number; output: number; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: string; output: string; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
  LocalDateTime: { input: string; output: string; }
  /** A 64-bit signed integer */
  Long: { input: number; output: number; }
}

export enum AccountClassification {
  Islamic = 'ISLAMIC',
  Standart = 'STANDART'
}

export interface AccountCurrencyAmountDto {
  __typename?: 'AccountCurrencyAmountDto';
  account: Scalars['String']['output'];
  amount: Scalars['BigDecimal']['output'];
  currency: CurrencyDto;
}

export interface AccountDto {
  __typename?: 'AccountDto';
  /** Номер счета */
  account: Scalars['String']['output'];
  /** Вид счёта STANDART/ISLAMIC */
  accountClassification: AccountClassification;
  /** Наименовании компании(владельца счета) */
  accountName: Maybe<Scalars['String']['output']>;
  /** Текущий баланс счета */
  balance: Scalars['BigDecimal']['output'];
  /** Бик банка, где открыт счет */
  bic: Scalars['String']['output'];
  /** Дата закрытия счета */
  closeDate: Maybe<Scalars['Date']['output']>;
  /** Номер контракта */
  contractNumber: Scalars['String']['output'];
  /** Информация о валюте */
  currency: CurrencyDto;
  /** Айди филиала банка, где открыт счет */
  departmentId: Scalars['Int']['output'];
  /** Айди счета */
  id: Scalars['Long']['output'];
  /** Процентная ставка */
  interestRate: Maybe<Scalars['BigDecimal']['output']>;
  /** Виден ли счет или скрыт */
  isVisible: Maybe<Scalars['Boolean']['output']>;
  /** Дата открытия счета */
  openDate: Maybe<Scalars['Date']['output']>;
  /** Айди организации */
  partyId: Scalars['Long']['output'];
  /** Планируемый остаток */
  plannedBalance: Maybe<Scalars['BigDecimal']['output']>;
  /** Текущий статус счета */
  status: AccountStatus;
  /** Тип счета */
  type: AccountType;
}

export interface AccountFilterInput {
  /** Список с типом счетов */
  accountTypes: Array<AccountType>;
  /** Айди организации */
  partyId: Scalars['Long']['input'];
  /** Текущие статусы счетов */
  statuses: Array<AccountStatus>;
}

/** Справочник статусов счета */
export enum AccountStatus {
  Arrested = 'ARRESTED',
  Closed = 'CLOSED',
  FinalArrested = 'FINAL_ARRESTED',
  Open = 'OPEN'
}

export enum AccountType {
  Card = 'CARD',
  Deposit = 'DEPOSIT',
  Loan = 'LOAN',
  Rko = 'RKO',
  Transit = 'TRANSIT'
}

export interface AccountWithPermissionFilterInput {
  /** Текущие статусы счетов */
  accountStatuses: Array<AccountStatus>;
  /** Список с типом счетов */
  accountTypes: Array<AccountType>;
  /** Текущие статусы карт счетов */
  cardStatuses: Array<AccountStatus>;
  /** Айди организации */
  partyId: Scalars['Long']['input'];
  /** Имя пользователя(айдишник) */
  username: Scalars['String']['input'];
}

export interface AccountWithPermissionList {
  __typename?: 'AccountWithPermissionList';
  /** Информация о счете */
  account: AccountDto;
  /** Доступные типы операций */
  availablePermissions: Array<PaymentType>;
  /** Информация о картах с доступами */
  cards: Maybe<Array<CardWithPermissionList>>;
  /** Типа операций */
  permissions: Array<PaymentType>;
}

export interface AvailableBalanceDetailsDto {
  __typename?: 'AvailableBalanceDetailsDto';
  account: Scalars['String']['output'];
  actualBalance: Scalars['BigDecimal']['output'];
  availableBalance: Scalars['BigDecimal']['output'];
  currency: CurrencyDto;
  processing: PaymentSummaryDto;
  signing: PaymentSummaryDto;
}

export interface AvailableBalanceRequestInput {
  accountId: Scalars['Long']['input'];
  legalPartyId: Scalars['Long']['input'];
}

export interface BalanceDto {
  __typename?: 'BalanceDto';
  /** Сумма денег */
  amount: Scalars['BigDecimal']['output'];
  /** Валюта */
  currency: Scalars['String']['output'];
}

export interface BalanceInfoByPeriod {
  __typename?: 'BalanceInfoByPeriod';
  /** Список сумм и валют на конец периода */
  endBalances: Array<BalanceDto>;
  /** Список сумм и валют на начало периода */
  startBalances: Array<BalanceDto>;
}

export interface Bank {
  __typename?: 'Bank';
  address: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
}

export enum BankPayloadType {
  /** номер счета */
  AccountNo = 'ACCOUNT_NO',
  /** банковский идентификационный номер */
  Bin = 'BIN',
  /** китайский код банка */
  Cnaps = 'CNAPS',
  /** корр. счет */
  CorrespondentAccount = 'CORRESPONDENT_ACCOUNT',
  /** международный банковский номер счета */
  Iban = 'IBAN',
  /** индивидуальный код счета */
  Iik = 'IIK',
  /** доп. текстовая информация */
  Info = 'INFO',
  /** идентификационный номер налогоплательщика */
  Inn = 'INN',
  /** код бюджетной единицы, используемый при платёжах в Казахстане */
  Kbe = 'KBE',
  /** локальный банковский идентификатор */
  LocalBic = 'LOCAL_BIC',
  /** номер маршрутизации */
  RoutingNumber = 'ROUTING_NUMBER',
  /** международный swift/bic код банка */
  SwiftBic = 'SWIFT_BIC'
}

export interface BaseAccountDto {
  __typename?: 'BaseAccountDto';
  /** Номер счета */
  account: Scalars['String']['output'];
  /** Вид счёта STANDART/ISLAMIC */
  accountClassification: Maybe<AccountClassification>;
  /** Наименования организации(владельца счета) */
  accountName: Maybe<Scalars['String']['output']>;
  /** Текущий баланс счета */
  balance: Scalars['BigDecimal']['output'];
  /** Бик банка, где открыт счет */
  bic: Scalars['String']['output'];
  /** Информация о валюте счета */
  currency: CurrencyDto;
  /** Айди филиала, где был заведен счет */
  departmentId: Scalars['Int']['output'];
  /** Айди счета */
  id: Scalars['Long']['output'];
  /** Айди организации */
  partyId: Scalars['Long']['output'];
  /** Текущий статус счета */
  status: AccountStatus;
  /** Тип счета */
  type: AccountType;
}

export interface CardAccountData {
  __typename?: 'CardAccountData';
  /** Информация о счете */
  account: AccountDto;
  /** Доступный баланс */
  availableAmount: Scalars['BigDecimal']['output'];
  /** Информация о карте с доступами */
  cards: Array<CardWithPermissionList>;
  /** Информации с валютой и суммой денег у валюты */
  multiBalance: Array<BalanceDto>;
}

export interface CardAccountFromEfrDto {
  __typename?: 'CardAccountFromEfrDto';
  /** Счет */
  account: Scalars['String']['output'];
  /** Список карт */
  cards: Array<CardFromEfrDto>;
}

export interface CardDto {
  __typename?: 'CardDto';
  /** Информация о счете */
  account: AccountDto;
  /** Имя владельца карты */
  cardHolderName: Scalars['String']['output'];
  /** Номер карты */
  cardNum: Scalars['String']['output'];
  /** Дата истечения карты */
  expiryDate: Scalars['Date']['output'];
  /** Айди карт счета */
  id: Scalars['Long']['output'];
  /** Тип платежной система(visa, master card и т.п) */
  paymentSystem: PaymentSystem;
  /** Рбс номер карты */
  rbsNumber: Scalars['String']['output'];
  /** Текущий статус счета */
  status: AccountStatus;
  /** Наименование платежной система */
  title: Scalars['String']['output'];
}

export interface CardFilterInput {
  /** Текущие статусы счетов */
  accountStatuses: Array<AccountStatus>;
  /** Текущие статусы карт счетов */
  cardStatuses: Array<AccountStatus>;
  /** Айди организации */
  partyId: Scalars['Long']['input'];
}

export interface CardFromEfrDto {
  __typename?: 'CardFromEfrDto';
  /** Маскированный номер карты */
  cardNum: Scalars['String']['output'];
  /** Айди физ.лица */
  partyId: Maybe<Scalars['Long']['output']>;
  /** Статус карты */
  state: Scalars['String']['output'];
}

export enum CardLimit {
  /** Интернет-покупки / платежи */
  CardNotPresent = 'CARD_NOT_PRESENT',
  /** Обналичивание денег в АТМ и кассовых POS-терминалах */
  CashLimit = 'CASH_LIMIT',
  /** Покупки через POS-терминалы */
  RetailCardPresent = 'RETAIL_CARD_PRESENT'
}

export interface CardLimitDto {
  __typename?: 'CardLimitDto';
  /** доступная сумма */
  availableAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** доступное кол-во транз. */
  availableNumber: Maybe<Scalars['Long']['output']>;
  /** дата окончания */
  endDate: Maybe<Scalars['Date']['output']>;
  /** Тип лимита */
  limitType: CardLimit;
  /** Макс сумма */
  maxAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Макс кол-во транзакций */
  maxNumber: Maybe<Scalars['Long']['output']>;
  /** дата начала */
  startDate: Maybe<Scalars['Date']['output']>;
  /** использованная сумма */
  usedAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** использованное кол-во транз. */
  usedNumber: Maybe<Scalars['Long']['output']>;
}

export enum CardPermission {
  GetLimitAndDetails = 'GET_LIMIT_AND_DETAILS',
  PushNotification = 'PUSH_NOTIFICATION',
  ReadCard = 'READ_CARD',
  SetLimit = 'SET_LIMIT',
  SetStatus = 'SET_STATUS'
}

export enum CardStatusesFromPc {
  CardBlocked = 'CARD_BLOCKED',
  CardCompromised = 'CARD_COMPROMISED',
  CardLost = 'CARD_LOST',
  CardStolen = 'CARD_STOLEN'
}

export interface CardWithPermissionList {
  __typename?: 'CardWithPermissionList';
  /** Текущие ограничения */
  availablePermissions: Array<CardPermission>;
  /** Информация о карт счете */
  card: CardDto;
  /** Ограничения */
  permissions: Array<CardPermission>;
}

export interface ChangeCardPermissionDto {
  /** Типы доступных действий */
  availablePermissions: Array<CardPermission>;
  /** Айди карты */
  cardId: Scalars['Long']['input'];
  /** Имя пользователя(айдишник) */
  username: Scalars['String']['input'];
}

export interface ChangePermissionDto {
  /** Айди счета */
  accountId: Scalars['Long']['input'];
  /** Типы доступных операций */
  availablePermissions: Array<PaymentType>;
  /** Имя пользователя(айдишник) */
  username: Scalars['String']['input'];
}

export interface CheckAvailableBalanceInput {
  legalPartyId: Scalars['Long']['input'];
  paymentIds: Array<Scalars['Long']['input']>;
}

export interface ContractTransactionsDto {
  __typename?: 'ContractTransactionsDTO';
  /** Сконвертированная сумма */
  baseAmount: Scalars['BigDecimal']['output'];
  /** Сумма комиссии */
  commissionAmount: Scalars['BigDecimal']['output'];
  /** Валюта комиссии */
  commissionCurrency: Scalars['String']['output'];
  settlementAmount: Scalars['BigDecimal']['output'];
  settlementCurrency: Scalars['String']['output'];
  sourceNumber: Maybe<Scalars['String']['output']>;
  targetNumber: Scalars['String']['output'];
  /** Сумма транзакции */
  transactionAmount: Scalars['BigDecimal']['output'];
  /** Валюта транзакции */
  transactionCurrency: Scalars['String']['output'];
  /** Дата и время проведения транзакции */
  transactionDate: Scalars['LocalDateTime']['output'];
  /** Назначения транзакции */
  transactionDetails: Scalars['String']['output'];
  /** Тип транзакции */
  transactionType: Scalars['String']['output'];
}

export interface ConvertAmountRequest {
  /** Сумма */
  amount: Scalars['BigDecimal']['input'];
  /** Валюта */
  currency: Scalars['String']['input'];
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Счет зачисления */
  requisites: Scalars['String']['input'];
  /** Счет списания */
  sourceAccount: Scalars['String']['input'];
  /** Тип метода пока только один - BY_ACCOUNT */
  typeMethod: Scalars['String']['input'];
}

export interface ConvertedAmountResponse {
  __typename?: 'ConvertedAmountResponse';
  /** Сумма зачисления */
  creditAmount: Scalars['BigDecimal']['output'];
  /** Валюта зачисления */
  creditCurrency: Maybe<Scalars['String']['output']>;
  creditRate: Maybe<Scalars['String']['output']>;
  /** Сумма списания */
  debitAmount: Scalars['BigDecimal']['output'];
  /** Валюта списания */
  debitCurrency: Maybe<Scalars['String']['output']>;
  debitRate: Maybe<Scalars['String']['output']>;
  /** Сумма комиссии */
  feeAmount: Scalars['BigDecimal']['output'];
  /** Валюта комиссии */
  feeCurrency: Maybe<Scalars['String']['output']>;
  /** Сумма операции */
  operationAmount: Scalars['BigDecimal']['output'];
  /** Валюта операции */
  operationCurrency: Scalars['String']['output'];
  /** Курс валют операции */
  operationRate: Scalars['BigDecimal']['output'];
}

export interface CorrespondentBankDto {
  __typename?: 'CorrespondentBankDto';
  address: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
}

export interface CorrespondentBankPayload {
  __typename?: 'CorrespondentBankPayload';
  type: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
}

export interface Currency {
  __typename?: 'Currency';
  code: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
}

export interface CurrencyDto {
  __typename?: 'CurrencyDto';
  /** Наименование валюты */
  description: Maybe<Scalars['String']['output']>;
  /** Международный код валюты */
  isoCode: Scalars['String']['output'];
  /** Международный номер валюты */
  isoNum: Scalars['String']['output'];
}

export interface Department {
  __typename?: 'Department';
  accountNumber: Maybe<Scalars['String']['output']>;
  address: Maybe<Scalars['String']['output']>;
  bic: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
}

export interface DirectoryResponse {
  __typename?: 'DirectoryResponse';
  /** Юридический адрес клиента */
  clientAddress: Maybe<Scalars['String']['output']>;
  /** Данные подразделения */
  department: Department;
  /** Данные реквизитов */
  requisites: Array<Requisite>;
}

export interface GenerateQrInput {
  /** Айди компании */
  legalPartyId: Scalars['Long']['input'];
  /** Тип генерации QR */
  qrGenerateType: QrGenerateType;
  /**
   * Объект соответствующий к полю 'qrGenerateType'
   * Если OB -> {"account": "1091820100040606", "sum": 1500}
   * Если SALE_POINT -> {"salePointCode": "2", "cashCode": "2", "legalPartyId": "248"}
   */
  value: Scalars['JSON']['input'];
}

export interface GetCardAccountFromEfrDto {
  /** Код филиала */
  departmentCode: InputMaybe<Scalars['Long']['input']>;
  /** Айди физ.лица */
  partyId: Scalars['Long']['input'];
}

export interface LegalPartyAndOperationId {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди qr операции в базе транзакционного сервиса */
  operationId: Scalars['String']['input'];
}

export interface LoanAccountChartsDto {
  __typename?: 'LoanAccountChartsDto';
  /** Информация о счете */
  account: AccountDto;
  /** Информация о кредите */
  charts: Array<LoanChart>;
}

export interface LoanAccountFilterInput {
  /** Текущие статусы счетов */
  accountStatuses: Array<AccountStatus>;
  /** Айди организации */
  partyId: Scalars['Long']['input'];
}

export interface LoanAccounts {
  __typename?: 'LoanAccounts';
  accRepayment: Maybe<Scalars['String']['output']>;
  /** Информация о счете */
  account: AccountDto;
  delaydayBy: Maybe<Scalars['String']['output']>;
  dutyNumber: Scalars['Long']['output'];
  lastActiveDate: Maybe<Scalars['Date']['output']>;
  /** Сумма кредита */
  loanAmount: Scalars['BigDecimal']['output'];
  loanId: Scalars['String']['output'];
  /** Сумма след платежа */
  nextPaymentAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Дата след платежа */
  nextPaymentDate: Maybe<Scalars['Date']['output']>;
  overdueOD: Maybe<Scalars['BigDecimal']['output']>;
  overduePR: Maybe<Scalars['BigDecimal']['output']>;
  overduePenya: Maybe<Scalars['BigDecimal']['output']>;
  paidPenya: Maybe<Scalars['BigDecimal']['output']>;
  paidProc: Maybe<Scalars['BigDecimal']['output']>;
  remainpayOD: Maybe<Scalars['BigDecimal']['output']>;
  remainpayPR: Maybe<Scalars['BigDecimal']['output']>;
}

export interface LoanChart {
  __typename?: 'LoanChart';
  amountCharge: Maybe<Scalars['BigDecimal']['output']>;
  /** погашение основного долга */
  amountODRepay: Maybe<Scalars['BigDecimal']['output']>;
  /** погашение срочных процентов */
  amountPercRepay: Maybe<Scalars['BigDecimal']['output']>;
  /** сумма разового платежа */
  amountRepay: Maybe<Scalars['BigDecimal']['output']>;
  /** Погашение реструктуризированного основного долга */
  amountRestOD: Maybe<Scalars['BigDecimal']['output']>;
  /** Погашение реструктуризированных %% на балансе */
  amountRestPerc: Maybe<Scalars['BigDecimal']['output']>;
  /** Погашение реструктуризированных %% на внесистемном учете */
  amountRestZPerc: Maybe<Scalars['BigDecimal']['output']>;
  /** остаток задолженности основого долга */
  balance: Maybe<Scalars['BigDecimal']['output']>;
  /** Дата платежа */
  lastPayDate: Maybe<Scalars['Date']['output']>;
  /** порядковый номер месяца в графике */
  month: Maybe<Scalars['Int']['output']>;
}

export interface LoanChartInput {
  /** Айди аккаунта с таблицы accounts */
  accountId: Scalars['Long']['input'];
  /** Тип кредита */
  dutyNumber: Scalars['Long']['input'];
  /** Айди кредита */
  loanId: Scalars['String']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Установка лимитов */
  setCardLimit: Scalars['Boolean']['output'];
  /** Изменение статуса карты */
  setCardStatus: Scalars['Boolean']['output'];
  /** Установка возможности проведения интернет платежей */
  setInternetTransactionsAvailability: Scalars['Boolean']['output'];
  /** Разблокировка карты */
  unlockCard: Scalars['Boolean']['output'];
  /** Изменение наименования карты */
  updateCardTitle: Scalars['String']['output'];
  /** Обновление доступов по счету для одного юзера */
  updatePermissions: Array<PaymentType>;
  /** Обновление доступов по карте для одного юзера */
  updatePermissionsCard: Array<CardPermission>;
  /** Обновление видимости счета для себя */
  updateVisible: Scalars['Boolean']['output'];
}


export interface MutationSetCardLimitArgs {
  cardId: Scalars['Long']['input'];
  setLimitInput: InputMaybe<SetLimitInput>;
}


export interface MutationSetCardStatusArgs {
  cardId: Scalars['Long']['input'];
  reason: Scalars['String']['input'];
  status: CardStatusesFromPc;
}


export interface MutationSetInternetTransactionsAvailabilityArgs {
  cardId: Scalars['Long']['input'];
  setInternetTransactionInput: SetInternetTransactionInput;
}


export interface MutationUnlockCardArgs {
  cardId: Scalars['Long']['input'];
  reason: Scalars['String']['input'];
}


export interface MutationUpdateCardTitleArgs {
  cardId: Scalars['Long']['input'];
  cardTitle: Scalars['String']['input'];
}


export interface MutationUpdatePermissionsArgs {
  changePermission: ChangePermissionDto;
}


export interface MutationUpdatePermissionsCardArgs {
  changePermission: ChangeCardPermissionDto;
}


export interface MutationUpdateVisibleArgs {
  accountId: Scalars['Long']['input'];
  isVisible: Scalars['Boolean']['input'];
}

export interface NaturalPersonCardAccountDto {
  __typename?: 'NaturalPersonCardAccountDto';
  /** Короткое имя */
  shortName: Scalars['String']['output'];
}

export interface NaturalPersonCardAccountInput {
  /** ID компании */
  legalPartyId: Scalars['Long']['input'];
  /** Номер телефона/счета */
  number: InputMaybe<Scalars['String']['input']>;
}

export interface NptDto {
  __typename?: 'NptDto';
  number: Maybe<Scalars['String']['output']>;
  paymentCode: Maybe<Scalars['String']['output']>;
  pdfLink: Scalars['String']['output'];
  pdfNoticeLink: Scalars['String']['output'];
  status: Maybe<Scalars['Int']['output']>;
  toPaySum: Maybe<Scalars['BigDecimal']['output']>;
}

export interface Payload {
  __typename?: 'Payload';
  type: Maybe<BankPayloadType>;
  value: Maybe<Scalars['String']['output']>;
}

export interface PaymentSummaryDto {
  __typename?: 'PaymentSummaryDto';
  paymentCount: Scalars['Long']['output'];
  totalAmount: Scalars['BigDecimal']['output'];
}

export enum PaymentSystem {
  Cup = 'CUP',
  Elcrd = 'ELCRD',
  MCard = 'MCard',
  Visa = 'VISA'
}

export enum PaymentType {
  BudgetPayment = 'BUDGET_PAYMENT',
  Clearing = 'CLEARING',
  Conversion = 'CONVERSION',
  GenerateQr = 'GENERATE_QR',
  Gross = 'GROSS',
  IntrabankTransferBusinessCard_2RkoForeign = 'INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_FOREIGN',
  IntrabankTransferBusinessCard_2RkoOwn = 'INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_OWN',
  IntrabankTransferForeign = 'INTRABANK_TRANSFER_FOREIGN',
  IntrabankTransferOwn = 'INTRABANK_TRANSFER_OWN',
  IntrabankTransferRko_2BusinessCard = 'INTRABANK_TRANSFER_RKO_2_BUSINESS_CARD',
  IntrabankTransferRko_2IndividualCard = 'INTRABANK_TRANSFER_RKO_2_INDIVIDUAL_CARD',
  PushNotification = 'PUSH_NOTIFICATION',
  Qr = 'QR',
  Read = 'READ',
  Refund = 'REFUND',
  Salary = 'SALARY',
  Swift = 'SWIFT',
  TransferByInvoice = 'TRANSFER_BY_INVOICE'
}

export interface PermissionDto {
  __typename?: 'PermissionDto';
  /** Описание операции */
  description: Maybe<Scalars['String']['output']>;
  /** Айди операции в базе operation */
  id: Scalars['Long']['output'];
  /** Тип операции */
  permission: PaymentType;
}

export interface QrDto {
  __typename?: 'QrDto';
  elQrUri: Scalars['String']['output'];
  elQrUrl: Scalars['String']['output'];
}

export enum QrGenerateType {
  Ob = 'OB',
  SalePoint = 'SALE_POINT'
}

/** Запросы для получения данных */
export interface Query {
  __typename?: 'Query';
  /** Проверка доступного остатка */
  checkAvailableAmount: Array<AccountCurrencyAmountDto>;
  /** Проверить счет зачисления на возможность возврата клиенту О24. При неуспешном ответе возвращает ошибку */
  checkRefundIsAvailableFromO24: RefundIsAvailableResponse;
  /** Сконвертировать сумму */
  convertAmount: ConvertedAmountResponse;
  /** Получение всех счетов по PartyID для которых разрешено permission */
  findAllAccountsByFilterWithPermissions: Array<AccountWithPermissionList>;
  /** Получение всех счетов по PartyID для админ */
  findAllAccountsByPartyIdAdmin: Array<AccountDto>;
  /** Получение всех счетов по PartyID фильтр ACL + видимых для себя счетов */
  findAllAccountsByPartyIdWithAcl: Array<AccountDto>;
  /** Получение валют счёта по счёту */
  findAllByAccount: Array<TransferAccountDto>;
  /** Получение счетов по фильтру(доступных для чтения в ACL) */
  findAllByFilter: Array<AccountDto>;
  /** Получение списка валют */
  findAllByIsoNums: Array<CurrencyDto>;
  /** Получение карточных счетов компании для внутренних переводов */
  findAllByPartyIdBaseCardAccountInfo: Array<BaseAccountDto>;
  /** Получение основной информации по счетам юр лица */
  findAllByPartyIdBaseRkoAccountInfo: Array<BaseAccountDto>;
  /** Получение карт по счету (только видимых) */
  findAllCardsByAccountId: CardAccountData;
  /** Получение карт по фильтру */
  findAllCardsByFilter: Array<CardAccountData>;
  /** Получение по номеру счета и валюты */
  findByAccountAndCurrency: TransferAccountDto;
  /** Генерация ElQR */
  generateElQr: QrDto;
  /** Получение всех счетов по LegalPartyId с указанием разрешении для конкретного юзера */
  getAccessControlListForUser: Array<AccountWithPermissionList>;
  /** Получение доступного остатка */
  getAccountBalance: AccountCurrencyAmountDto;
  getAccountById: AccountDto;
  /** Получение счёта по торговой точке */
  getAccountBySalePointCode: BaseAccountDto;
  /** Получение доступных счетов для торговой точки */
  getAllAccountsForSalePoint: Array<BaseAccountDto>;
  /** Получение списка разрешении */
  getAllPermissionList: Array<PermissionDto>;
  /** Получение доступных операции по счету */
  getAllowedPaymentTypes: Array<PaymentType>;
  /** Получение статусов для карты */
  getAvailableStatusesForCard: Array<CardStatusesFromPc>;
  /** Получение остатка счета на начало и конец периода */
  getBalanceInfoByPeriod: BalanceInfoByPeriod;
  /** Получение зп.счетов физ. лица из ЕФР */
  getCardAccountsFromEfr: Array<CardAccountFromEfrDto>;
  /** Получение лимитов по карте */
  getCardLimitInfo: Array<CardLimitDto>;
  /** Получение полной информации по доступному остатку */
  getFullInfoAboutAvailableBalance: AvailableBalanceDetailsDto;
  /** Получение статуса возможности проведения интернет платежей */
  getInternetTransactionsAvailability: Scalars['Boolean']['output'];
  /** Получение кредитных счетов */
  getLoanAccounts: Array<LoanAccounts>;
  /** Получение графика выплат кредита по кредитному счёту (физ./юр. лиц) */
  getLoanCharts: LoanAccountChartsDto;
  /** Получение карты по номеру счета/телефона. */
  getNaturalPersonCards: NaturalPersonCardAccountDto;
  /** Получение Npt компании по legalPartyId */
  getNptByLegalPartyId: Array<NptDto>;
  /** Получение списка операции по карт. счету */
  getOperationList: Array<ContractTransactionsDto>;
  /** Получение информации по возвращенной qr операции */
  getRefundedQrOperationInfo: RefundedQrOperationDetail;
  /**
   * Получение реквизитов на оплату
   * Так как данный метод под капотом стучится в сервис О24 - может вернуть новые классификаторы
   * ошибок: DEPARTMENT_NOT_FOUND,DEPARTMENT_FOR_REQUISITE_NOT_FOUND,UNEXPECTED_ERROR(в случаи непредвиденной ошибки)
   */
  getRequisitesByCurrency: Maybe<DirectoryResponse>;
}


/** Запросы для получения данных */
export interface QueryCheckAvailableAmountArgs {
  checkAvailableBalanceInput: CheckAvailableBalanceInput;
}


/** Запросы для получения данных */
export interface QueryCheckRefundIsAvailableFromO24Args {
  params: LegalPartyAndOperationId;
}


/** Запросы для получения данных */
export interface QueryConvertAmountArgs {
  convertAmountRequest: ConvertAmountRequest;
}


/** Запросы для получения данных */
export interface QueryFindAllAccountsByFilterWithPermissionsArgs {
  filterInput: AccountFilterInput;
  permissions: Array<PaymentType>;
}


/** Запросы для получения данных */
export interface QueryFindAllAccountsByPartyIdAdminArgs {
  partyId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryFindAllAccountsByPartyIdWithAclArgs {
  filterInput: AccountFilterInput;
}


/** Запросы для получения данных */
export interface QueryFindAllByAccountArgs {
  account: Scalars['String']['input'];
}


/** Запросы для получения данных */
export interface QueryFindAllByFilterArgs {
  filterInput: AccountFilterInput;
}


/** Запросы для получения данных */
export interface QueryFindAllByIsoNumsArgs {
  isoNums: InputMaybe<Array<Scalars['String']['input']>>;
}


/** Запросы для получения данных */
export interface QueryFindAllByPartyIdBaseCardAccountInfoArgs {
  partyId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryFindAllByPartyIdBaseRkoAccountInfoArgs {
  partyId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryFindAllCardsByAccountIdArgs {
  accountId: Scalars['Long']['input'];
  cardStatuses: Array<AccountStatus>;
}


/** Запросы для получения данных */
export interface QueryFindAllCardsByFilterArgs {
  filterInput: CardFilterInput;
}


/** Запросы для получения данных */
export interface QueryFindByAccountAndCurrencyArgs {
  account: Scalars['String']['input'];
  currencyNum: Scalars['String']['input'];
}


/** Запросы для получения данных */
export interface QueryGenerateElQrArgs {
  generateQrInput: GenerateQrInput;
}


/** Запросы для получения данных */
export interface QueryGetAccessControlListForUserArgs {
  filter: AccountWithPermissionFilterInput;
}


/** Запросы для получения данных */
export interface QueryGetAccountBalanceArgs {
  availableBalanceRequestInput: AvailableBalanceRequestInput;
}


/** Запросы для получения данных */
export interface QueryGetAccountByIdArgs {
  accountId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetAccountBySalePointCodeArgs {
  salePointQr: SalePointAccount;
}


/** Запросы для получения данных */
export interface QueryGetAllAccountsForSalePointArgs {
  legalPartyId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetAllowedPaymentTypesArgs {
  accountId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetAvailableStatusesForCardArgs {
  cardId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetBalanceInfoByPeriodArgs {
  accountId: Scalars['Long']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
}


/** Запросы для получения данных */
export interface QueryGetCardAccountsFromEfrArgs {
  getCardAccountFromEfr: GetCardAccountFromEfrDto;
  legalPartyId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetCardLimitInfoArgs {
  cardId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetFullInfoAboutAvailableBalanceArgs {
  availableBalanceRequestInput: AvailableBalanceRequestInput;
}


/** Запросы для получения данных */
export interface QueryGetInternetTransactionsAvailabilityArgs {
  cardId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetLoanAccountsArgs {
  filterInput: LoanAccountFilterInput;
}


/** Запросы для получения данных */
export interface QueryGetLoanChartsArgs {
  loanChartInput: LoanChartInput;
}


/** Запросы для получения данных */
export interface QueryGetNaturalPersonCardsArgs {
  naturalPersonCardAccountInput: NaturalPersonCardAccountInput;
}


/** Запросы для получения данных */
export interface QueryGetNptByLegalPartyIdArgs {
  legalPartyId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetOperationListArgs {
  accountId: Scalars['Long']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
}


/** Запросы для получения данных */
export interface QueryGetRefundedQrOperationInfoArgs {
  baseOperationId: Scalars['String']['input'];
  legalPartyId: Scalars['Long']['input'];
}


/** Запросы для получения данных */
export interface QueryGetRequisitesByCurrencyArgs {
  accountId: Scalars['Long']['input'];
  currencyNumber: Scalars['String']['input'];
  departmentCode: Scalars['Int']['input'];
}

export interface RefundIsAvailableResponse {
  __typename?: 'RefundIsAvailableResponse';
  /** Доступный баланс для возврата */
  availableRefundAmount: Scalars['BigDecimal']['output'];
  /** Маскированный номер карты */
  maskedAccount: Scalars['String']['output'];
  /** Имя получателя */
  recipientName: Scalars['String']['output'];
}

export interface RefundedQrOperationDetail {
  __typename?: 'RefundedQrOperationDetail';
  /** Сумма основной операции */
  amountOfBaseOperation: Scalars['BigDecimal']['output'];
  /** ФИО владельца карты О24 */
  cardHolderName: Scalars['String']['output'];
  /** Номер карты О24 */
  cardNum: Scalars['String']['output'];
  /** Имя отправителя */
  createdDateTime: Scalars['String']['output'];
  /** Сумма комиссии основной операции */
  feeAmountOfBaseOperation: Maybe<Scalars['BigDecimal']['output']>;
  /** Процент комиссии основной операции */
  feePercentOfBaseOperation: Maybe<Scalars['BigDecimal']['output']>;
  /** Статус операции в транзакционном сервисе */
  operationStatus: Scalars['String']['output'];
  /** Тип операции в транзакционном сервисе */
  operationType: Scalars['String']['output'];
  /** Текст с причиной возврата */
  purpose: Scalars['String']['output'];
  /** Айди транзакции */
  qrTransactionId: Scalars['String']['output'];
  /** Сумма возвращенной операции */
  refundedAmount: Scalars['BigDecimal']['output'];
  /** Чек возвращенной операции */
  refundedOperationStan: Scalars['String']['output'];
  /** Адрес торговой точки если основная операция была по торговой точке */
  salePointAddress: Maybe<Scalars['String']['output']>;
  /** Касса торговой точки если основная операция была по торговой точке */
  salePointCash: Maybe<Scalars['Int']['output']>;
  /** Чек основной операции */
  stanOfBaseOperation: Scalars['String']['output'];
}

export interface Requisite {
  __typename?: 'Requisite';
  /** Комментарий */
  comment: Maybe<Scalars['String']['output']>;
  /** Корреспондентский банк */
  correspondentBank: Maybe<CorrespondentBankDto>;
  /** Данные о банке корреспонденте */
  correspondentBankPayload: Maybe<Array<Maybe<CorrespondentBankPayload>>>;
  /** Данные о валюте */
  currency: Maybe<Currency>;
  /** Данные банка посредника */
  intermediaryBank: Maybe<Bank>;
  /** Доп данные банка посредника */
  intermediaryBankPayload: Array<Maybe<Payload>>;
  /** Данные банка получателя */
  recipientBank: Maybe<Bank>;
  /** Доп данные банка получателя */
  recipientBankPayload: Array<Maybe<Payload>>;
}

export interface SalePointAccount {
  /** Айди компании */
  legalPartyId: Scalars['Long']['input'];
  /** Код торговой точки */
  salePointCode: Scalars['Int']['input'];
}

export interface SetInternetTransactionInput {
  /** Вкл/Выкл */
  isActive: Scalars['Boolean']['input'];
  /** Причина */
  reason: Scalars['String']['input'];
}

export interface SetLimitInput {
  /** Комментарий */
  comment: Scalars['String']['input'];
  /** Дата конца */
  endDate: Scalars['Date']['input'];
  /** Тип лимита */
  limitType: CardLimit;
  /** Максимальная сумма */
  maxAmount: Scalars['BigDecimal']['input'];
  maxNumber: Scalars['Long']['input'];
  /** Дата начало */
  startDate: Scalars['Date']['input'];
}

export interface TransferAccountDto {
  __typename?: 'TransferAccountDto';
  /** Номер счета */
  account: Scalars['String']['output'];
  /** Наименования организации(владельца счета) */
  accountName: Maybe<Scalars['String']['output']>;
  /** Бик банка, где открыт счет */
  bic: Scalars['String']['output'];
  /** Информация о валюте счета */
  currency: CurrencyDto;
  /** Айди счета */
  id: Scalars['Long']['output'];
}

export type AvailableBalanceDetailsFragment = { __typename?: 'AvailableBalanceDetailsDto', account: string, actualBalance: number, availableBalance: number, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string }, signing: { __typename?: 'PaymentSummaryDto', totalAmount: number, paymentCount: number }, processing: { __typename?: 'PaymentSummaryDto', totalAmount: number, paymentCount: number } };

export type AccountCurrencyAmountFragment = { __typename?: 'AccountCurrencyAmountDto', account: string, amount: number, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } };

export type GetAccountBalanceQueryVariables = Exact<{
  availableBalanceRequestInput: AvailableBalanceRequestInput;
}>;


export type GetAccountBalanceQuery = { __typename?: 'Query', getAccountBalance: { __typename?: 'AccountCurrencyAmountDto', account: string, amount: number, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } } };

export type GetFullInfoAboutAvailableBalanceQueryVariables = Exact<{
  availableBalanceRequestInput: AvailableBalanceRequestInput;
}>;


export type GetFullInfoAboutAvailableBalanceQuery = { __typename?: 'Query', getFullInfoAboutAvailableBalance: { __typename?: 'AvailableBalanceDetailsDto', account: string, actualBalance: number, availableBalance: number, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string }, signing: { __typename?: 'PaymentSummaryDto', totalAmount: number, paymentCount: number }, processing: { __typename?: 'PaymentSummaryDto', totalAmount: number, paymentCount: number } } };

export type CurrencyForAccountFragment = { __typename?: 'CurrencyDto', isoCode: string, isoNum: string };

export type AccountFragment = { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } };

export type TransferAccountFragment = { __typename?: 'TransferAccountDto', id: number, account: string, accountName: string | null, bic: string, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } };

export type BaseAccountFragment = { __typename?: 'BaseAccountDto', id: number, bic: string, partyId: number, account: string, balance: number, accountName: string | null, departmentId: number, type: AccountType, accountClassification: AccountClassification | null, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } };

export type BalanceFragment = { __typename?: 'BalanceDto', amount: number, currency: string };

export type AccountWithPermissionListFragment = { __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } } };

export type AccountWithPermissionListForPaymentFragment = { __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null };

export type ContractTransactionsFragment = { __typename?: 'ContractTransactionsDTO', baseAmount: number, transactionAmount: number, transactionCurrency: string, settlementAmount: number, settlementCurrency: string, transactionDetails: string, transactionDate: string, commissionAmount: number, commissionCurrency: string };

export type CardDataForDetailFragment = { __typename?: 'CardAccountData', availableAmount: number, account: { __typename?: 'AccountDto', account: string, id: number }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, paymentSystem: PaymentSystem, cardHolderName: string } }>, multiBalance: Array<{ __typename?: 'BalanceDto', currency: string, amount: number }> };

export type CardLimitInfoFragment = { __typename?: 'CardLimitDto', limitType: CardLimit, maxAmount: number | null, maxNumber: number | null, availableAmount: number | null, availableNumber: number | null, usedAmount: number | null, usedNumber: number | null, startDate: string | null, endDate: string | null };

export type AccountsIdFragment = { __typename?: 'AccountDto', id: number };

export type CardDataFragment = { __typename?: 'CardAccountData', availableAmount: number, multiBalance: Array<{ __typename?: 'BalanceDto', amount: number, currency: string }>, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> };

export type CardFragment = { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } };

export type CardWithPermissionListFragment = { __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } };

export type AccountWithPermissionListForPaymentCardFragment = { __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, account: string }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null };

export type AccountForQrFragment = { __typename?: 'AccountWithPermissionList', account: { __typename?: 'AccountDto', account: string, type: AccountType, accountClassification: AccountClassification }, cards: Array<{ __typename?: 'CardWithPermissionList', card: { __typename?: 'CardDto', title: string, cardNum: string, cardHolderName: string, account: { __typename?: 'AccountDto', account: string, accountClassification: AccountClassification } } }> | null };

export type ElQrFragment = { __typename?: 'QrDto', elQrUri: string, elQrUrl: string };

export type BalanceInfoByPeriodFragment = { __typename?: 'BalanceInfoByPeriod', startBalances: Array<{ __typename?: 'BalanceDto', currency: string, amount: number }>, endBalances: Array<{ __typename?: 'BalanceDto', currency: string, amount: number }> };

export type NptFragment = { __typename?: 'NptDto', pdfLink: string, pdfNoticeLink: string };

export type ConvertedAmountResponseFragment = { __typename?: 'ConvertedAmountResponse', operationRate: number, operationCurrency: string, debitAmount: number, debitCurrency: string | null, creditAmount: number, creditCurrency: string | null, debitRate: string | null };

export type RefundQrOperationDetailFragment = { __typename?: 'RefundedQrOperationDetail', createdDateTime: string, operationStatus: string, purpose: string, operationType: string, stanOfBaseOperation: string, refundedOperationStan: string, cardHolderName: string, cardNum: string, amountOfBaseOperation: number, refundedAmount: number, feeAmountOfBaseOperation: number | null, feePercentOfBaseOperation: number | null, qrTransactionId: string, salePointAddress: string | null, salePointCash: number | null };

export type QrRefundIsAvailableResponseFragment = { __typename?: 'RefundIsAvailableResponse', availableRefundAmount: number, maskedAccount: string, recipientName: string };

export type AccountReqFragment = { __typename?: 'AccountDto', account: string, id: number, departmentId: number, contractNumber: string, currency: { __typename?: 'CurrencyDto', isoNum: string } };

export type CardAccountReqFragment = { __typename?: 'CardAccountData', account: { __typename?: 'AccountDto', account: string, departmentId: number, id: number, currency: { __typename?: 'CurrencyDto', isoNum: string } } };

export type DirectoryReqFragment = { __typename?: 'DirectoryResponse', clientAddress: string | null, department: { __typename?: 'Department', name: string | null, address: string | null, bic: number | null, accountNumber: string | null }, requisites: Array<{ __typename?: 'Requisite', comment: string | null, recipientBank: { __typename?: 'Bank', swiftCode: string | null, address: string | null, name: string | null } | null, intermediaryBank: { __typename?: 'Bank', swiftCode: string | null, address: string | null, name: string | null } | null, recipientBankPayload: Array<{ __typename?: 'Payload', value: string | null, type: BankPayloadType | null } | null>, intermediaryBankPayload: Array<{ __typename?: 'Payload', type: BankPayloadType | null, value: string | null } | null>, currency: { __typename?: 'Currency', code: string | null } | null, correspondentBankPayload: Array<{ __typename?: 'CorrespondentBankPayload', value: string | null, type: string | null } | null> | null, correspondentBank: { __typename?: 'CorrespondentBankDto', swiftCode: string | null, name: string | null, address: string | null } | null }> };

export type CardFromEfrFragment = { __typename?: 'CardFromEfrDto', partyId: number | null, cardNum: string, state: string };

export type CardAccountFromEfrFragment = { __typename?: 'CardAccountFromEfrDto', account: string, cards: Array<{ __typename?: 'CardFromEfrDto', partyId: number | null, cardNum: string, state: string }> };

export type AccountMainFragment = { __typename?: 'AccountDto', id: number, status: AccountStatus, account: string, balance: number, isVisible: boolean | null, contractNumber: string, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string } };

export type UpdatePermissionsMutationVariables = Exact<{
  changePermission: ChangePermissionDto;
}>;


export type UpdatePermissionsMutation = { __typename?: 'Mutation', updatePermissions: Array<PaymentType> };

export type UpdatePermissionsCardMutationVariables = Exact<{
  changePermission: ChangeCardPermissionDto;
}>;


export type UpdatePermissionsCardMutation = { __typename?: 'Mutation', updatePermissionsCard: Array<CardPermission> };

export type UpdateVisibleMutationVariables = Exact<{
  accountId: Scalars['Long']['input'];
  isVisible: Scalars['Boolean']['input'];
}>;


export type UpdateVisibleMutation = { __typename?: 'Mutation', updateVisible: boolean };

export type SetCardStatusMutationVariables = Exact<{
  cardId: Scalars['Long']['input'];
  status: CardStatusesFromPc;
  reason: Scalars['String']['input'];
}>;


export type SetCardStatusMutation = { __typename?: 'Mutation', setCardStatus: boolean };

export type SetInternetTransactionsAvailabilityMutationVariables = Exact<{
  cardId: Scalars['Long']['input'];
  setInternetTransactionInput: SetInternetTransactionInput;
}>;


export type SetInternetTransactionsAvailabilityMutation = { __typename?: 'Mutation', setInternetTransactionsAvailability: boolean };

export type SetCardLimitMutationVariables = Exact<{
  cardId: Scalars['Long']['input'];
  setSetLimitInput: SetLimitInput;
}>;


export type SetCardLimitMutation = { __typename?: 'Mutation', setCardLimit: boolean };

export type UnlockCardMutationVariables = Exact<{
  cardId: Scalars['Long']['input'];
  reason: Scalars['String']['input'];
}>;


export type UnlockCardMutation = { __typename?: 'Mutation', unlockCard: boolean };

export type UpdateCardTitleMutationVariables = Exact<{
  cardId: Scalars['Long']['input'];
  cardTitle: Scalars['String']['input'];
}>;


export type UpdateCardTitleMutation = { __typename?: 'Mutation', updateCardTitle: string };

export type FindAllAccountsByPartyIdWithAclQueryVariables = Exact<{
  filterInput: AccountFilterInput;
}>;


export type FindAllAccountsByPartyIdWithAclQuery = { __typename?: 'Query', findAllAccountsByPartyIdWithAcl: Array<{ __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type FindAllAccountsByPartyIdWithAclMainQueryVariables = Exact<{
  filterInput: AccountFilterInput;
}>;


export type FindAllAccountsByPartyIdWithAclMainQuery = { __typename?: 'Query', findAllAccountsByPartyIdWithAcl: Array<{ __typename?: 'AccountDto', id: number, status: AccountStatus, account: string, balance: number, isVisible: boolean | null, contractNumber: string, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string } }> };

export type FindAllAccountsByFilterWithPermissionsQueryVariables = Exact<{
  filterInput: AccountFilterInput;
  permissions: Array<PaymentType> | PaymentType;
}>;


export type FindAllAccountsByFilterWithPermissionsQuery = { __typename?: 'Query', findAllAccountsByFilterWithPermissions: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }> };

export type GetAccessControlListForUserQueryVariables = Exact<{
  filter: AccountWithPermissionFilterInput;
}>;


export type GetAccessControlListForUserQuery = { __typename?: 'Query', getAccessControlListForUser: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }> };

export type GetAccessControlListForUserCardQueryVariables = Exact<{
  filter: AccountWithPermissionFilterInput;
}>;


export type GetAccessControlListForUserCardQuery = { __typename?: 'Query', getAccessControlListForUser: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, account: string }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }> };

export type GetAccountByIdQueryVariables = Exact<{
  accountId: Scalars['Long']['input'];
}>;


export type GetAccountByIdQuery = { __typename?: 'Query', getAccountById: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } } };

export type FindByAccountAndCurrencyQueryVariables = Exact<{
  account: Scalars['String']['input'];
  currencyNum: Scalars['String']['input'];
}>;


export type FindByAccountAndCurrencyQuery = { __typename?: 'Query', findByAccountAndCurrency: { __typename?: 'TransferAccountDto', id: number, account: string, accountName: string | null, bic: string, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } } };

export type FindAllByAccountQueryVariables = Exact<{
  account: Scalars['String']['input'];
}>;


export type FindAllByAccountQuery = { __typename?: 'Query', findAllByAccount: Array<{ __typename?: 'TransferAccountDto', id: number, account: string, accountName: string | null, bic: string, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type FindAllByPartyIdBaseRkoAccountInfoQueryVariables = Exact<{
  partyId: Scalars['Long']['input'];
}>;


export type FindAllByPartyIdBaseRkoAccountInfoQuery = { __typename?: 'Query', findAllByPartyIdBaseRkoAccountInfo: Array<{ __typename?: 'BaseAccountDto', id: number, bic: string, partyId: number, account: string, balance: number, accountName: string | null, departmentId: number, type: AccountType, accountClassification: AccountClassification | null, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type FindAllByPartyIdBaseCardAccountInfoQueryVariables = Exact<{
  partyId: Scalars['Long']['input'];
}>;


export type FindAllByPartyIdBaseCardAccountInfoQuery = { __typename?: 'Query', findAllByPartyIdBaseCardAccountInfo: Array<{ __typename?: 'BaseAccountDto', id: number, bic: string, partyId: number, account: string, balance: number, accountName: string | null, departmentId: number, type: AccountType, accountClassification: AccountClassification | null, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type FindAllByFilterQueryVariables = Exact<{
  filterInput: AccountFilterInput;
}>;


export type FindAllByFilterQuery = { __typename?: 'Query', findAllByFilter: Array<{ __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type GetAccountsWithPermissionsAndBaseQueryVariables = Exact<{
  filterInput: AccountFilterInput;
  permissions: Array<PaymentType> | PaymentType;
  partyId: Scalars['Long']['input'];
}>;


export type GetAccountsWithPermissionsAndBaseQuery = { __typename?: 'Query', findAllAccountsByFilterWithPermissions: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }>, findAllByPartyIdBaseRkoAccountInfo: Array<{ __typename?: 'BaseAccountDto', id: number, bic: string, partyId: number, account: string, balance: number, accountName: string | null, departmentId: number, type: AccountType, accountClassification: AccountClassification | null, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type GetCardTransferToBusinessQueryVariables = Exact<{
  filterInput: AccountFilterInput;
  permissions: Array<PaymentType> | PaymentType;
  cardFilterInput: CardFilterInput;
}>;


export type GetCardTransferToBusinessQuery = { __typename?: 'Query', findAllAccountsByFilterWithPermissions: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }>, findAllCardsByFilter: Array<{ __typename?: 'CardAccountData', availableAmount: number, multiBalance: Array<{ __typename?: 'BalanceDto', amount: number, currency: string }>, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> }> };

export type GetCardTransferToRKoQueryVariables = Exact<{
  cardFilterInput: CardFilterInput;
  partyId: Scalars['Long']['input'];
}>;


export type GetCardTransferToRKoQuery = { __typename?: 'Query', findAllCardsByFilter: Array<{ __typename?: 'CardAccountData', availableAmount: number, multiBalance: Array<{ __typename?: 'BalanceDto', amount: number, currency: string }>, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> }>, findAllByPartyIdBaseRkoAccountInfo: Array<{ __typename?: 'BaseAccountDto', id: number, bic: string, partyId: number, account: string, balance: number, accountName: string | null, departmentId: number, type: AccountType, accountClassification: AccountClassification | null, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type GetSwiftAccountsQueryVariables = Exact<{
  filterInput: AccountFilterInput;
  accountPermissions: Array<PaymentType> | PaymentType;
  commissionAccountPermissions: Array<PaymentType> | PaymentType;
}>;


export type GetSwiftAccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }>, commissionAccounts: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }> };

export type GetRkoAccountsAndCardsQueryVariables = Exact<{
  accountFilterInput: AccountFilterInput;
  permissions: Array<PaymentType> | PaymentType;
  cardFilterInput: CardFilterInput;
}>;


export type GetRkoAccountsAndCardsQuery = { __typename?: 'Query', findAllAccountsByFilterWithPermissions: Array<{ __typename?: 'AccountWithPermissionList', permissions: Array<PaymentType>, availablePermissions: Array<PaymentType>, account: { __typename?: 'AccountDto', id: number, bic: string, type: AccountType, status: AccountStatus, partyId: number, account: string, balance: number, plannedBalance: number | null, interestRate: number | null, accountName: string | null, closeDate: string | null, isVisible: boolean | null, contractNumber: string, departmentId: number, accountClassification: AccountClassification, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, availablePermissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> | null }>, findAllCardsByFilter: Array<{ __typename?: 'CardAccountData', availableAmount: number, multiBalance: Array<{ __typename?: 'BalanceDto', amount: number, currency: string }>, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> }> };

export type FindAllCardsByFilterQueryVariables = Exact<{
  filterInput: CardFilterInput;
}>;


export type FindAllCardsByFilterQuery = { __typename?: 'Query', findAllCardsByFilter: Array<{ __typename?: 'CardAccountData', availableAmount: number, multiBalance: Array<{ __typename?: 'BalanceDto', amount: number, currency: string }>, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> }> };

export type FindAllAccountsByPartyIdWithAclIdQueryVariables = Exact<{
  filterInput: AccountFilterInput;
}>;


export type FindAllAccountsByPartyIdWithAclIdQuery = { __typename?: 'Query', findAllAccountsByPartyIdWithAcl: Array<{ __typename?: 'AccountDto', id: number }> };

export type FindAllCardsDetailByAccountIdQueryVariables = Exact<{
  accountId: Scalars['Long']['input'];
  cardStatuses: Array<AccountStatus> | AccountStatus;
}>;


export type FindAllCardsDetailByAccountIdQuery = { __typename?: 'Query', findAllCardsByAccountId: { __typename?: 'CardAccountData', availableAmount: number, account: { __typename?: 'AccountDto', account: string, id: number }, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, paymentSystem: PaymentSystem, cardHolderName: string } }>, multiBalance: Array<{ __typename?: 'BalanceDto', currency: string, amount: number }> } };

export type FindAllCardsByAccountIdQueryVariables = Exact<{
  accountId: Scalars['Long']['input'];
  cardStatuses: Array<AccountStatus> | AccountStatus;
}>;


export type FindAllCardsByAccountIdQuery = { __typename?: 'Query', findAllCardsByAccountId: { __typename?: 'CardAccountData', availableAmount: number, multiBalance: Array<{ __typename?: 'BalanceDto', amount: number, currency: string }>, cards: Array<{ __typename?: 'CardWithPermissionList', permissions: Array<CardPermission>, card: { __typename?: 'CardDto', id: number, cardNum: string, rbsNumber: string, cardHolderName: string, expiryDate: string, title: string, status: AccountStatus, paymentSystem: PaymentSystem, account: { __typename?: 'AccountDto', id: number, account: string, bic: string } } }> } };

export type GetOperationListQueryVariables = Exact<{
  accountId: Scalars['Long']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type GetOperationListQuery = { __typename?: 'Query', getOperationList: Array<{ __typename?: 'ContractTransactionsDTO', baseAmount: number, transactionAmount: number, transactionCurrency: string, settlementAmount: number, settlementCurrency: string, transactionDetails: string, transactionDate: string, commissionAmount: number, commissionCurrency: string }> };

export type GetAvailableStatusesForCardQueryVariables = Exact<{
  cardId: Scalars['Long']['input'];
}>;


export type GetAvailableStatusesForCardQuery = { __typename?: 'Query', getAvailableStatusesForCard: Array<CardStatusesFromPc> };

export type GetInternetTransactionsAvailabilityQueryVariables = Exact<{
  cardId: Scalars['Long']['input'];
}>;


export type GetInternetTransactionsAvailabilityQuery = { __typename?: 'Query', getInternetTransactionsAvailability: boolean };

export type FindAllAccountByFilterForQrQueryVariables = Exact<{
  filterInput: AccountFilterInput;
  permissions: Array<PaymentType> | PaymentType;
}>;


export type FindAllAccountByFilterForQrQuery = { __typename?: 'Query', findAllAccountsByFilterWithPermissions: Array<{ __typename?: 'AccountWithPermissionList', account: { __typename?: 'AccountDto', account: string, type: AccountType, accountClassification: AccountClassification }, cards: Array<{ __typename?: 'CardWithPermissionList', card: { __typename?: 'CardDto', title: string, cardNum: string, cardHolderName: string, account: { __typename?: 'AccountDto', account: string, accountClassification: AccountClassification } } }> | null }> };

export type GenerateElQrQueryVariables = Exact<{
  generateQrInput: GenerateQrInput;
}>;


export type GenerateElQrQuery = { __typename?: 'Query', generateElQr: { __typename?: 'QrDto', elQrUri: string, elQrUrl: string } };

export type GetCardLimitInfoQueryVariables = Exact<{
  cardId: Scalars['Long']['input'];
}>;


export type GetCardLimitInfoQuery = { __typename?: 'Query', getCardLimitInfo: Array<{ __typename?: 'CardLimitDto', limitType: CardLimit, maxAmount: number | null, maxNumber: number | null, availableAmount: number | null, availableNumber: number | null, usedAmount: number | null, usedNumber: number | null, startDate: string | null, endDate: string | null }> };

export type GetNaturalPersonByPhoneOrCardQueryVariables = Exact<{
  naturalPersonCardAccountInput: NaturalPersonCardAccountInput;
}>;


export type GetNaturalPersonByPhoneOrCardQuery = { __typename?: 'Query', getNaturalPersonCards: { __typename?: 'NaturalPersonCardAccountDto', shortName: string } };

export type GetAllAccountsForSalePointQueryVariables = Exact<{
  legalPartyId: Scalars['Long']['input'];
}>;


export type GetAllAccountsForSalePointQuery = { __typename?: 'Query', getAllAccountsForSalePoint: Array<{ __typename?: 'BaseAccountDto', id: number, bic: string, partyId: number, account: string, balance: number, accountName: string | null, departmentId: number, type: AccountType, accountClassification: AccountClassification | null, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } }> };

export type GetAccountBySalePointCodeQueryVariables = Exact<{
  salePointQr: SalePointAccount;
}>;


export type GetAccountBySalePointCodeQuery = { __typename?: 'Query', getAccountBySalePointCode: { __typename?: 'BaseAccountDto', id: number, bic: string, partyId: number, account: string, balance: number, accountName: string | null, departmentId: number, type: AccountType, accountClassification: AccountClassification | null, currency: { __typename?: 'CurrencyDto', isoCode: string, isoNum: string } } };

export type GetBalanceInfoByPeriodQueryVariables = Exact<{
  accountId: Scalars['Long']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type GetBalanceInfoByPeriodQuery = { __typename?: 'Query', getBalanceInfoByPeriod: { __typename?: 'BalanceInfoByPeriod', startBalances: Array<{ __typename?: 'BalanceDto', currency: string, amount: number }>, endBalances: Array<{ __typename?: 'BalanceDto', currency: string, amount: number }> } };

export type GetNptByLegalPartyIdQueryVariables = Exact<{
  legalPartyId: Scalars['Long']['input'];
}>;


export type GetNptByLegalPartyIdQuery = { __typename?: 'Query', getNptByLegalPartyId: Array<{ __typename?: 'NptDto', pdfLink: string, pdfNoticeLink: string }> };

export type GetRefundedQrOperationInfoQueryVariables = Exact<{
  baseOperationId: Scalars['String']['input'];
  legalPartyId: Scalars['Long']['input'];
}>;


export type GetRefundedQrOperationInfoQuery = { __typename?: 'Query', getRefundedQrOperationInfo: { __typename?: 'RefundedQrOperationDetail', createdDateTime: string, operationStatus: string, purpose: string, operationType: string, stanOfBaseOperation: string, refundedOperationStan: string, cardHolderName: string, cardNum: string, amountOfBaseOperation: number, refundedAmount: number, feeAmountOfBaseOperation: number | null, feePercentOfBaseOperation: number | null, qrTransactionId: string, salePointAddress: string | null, salePointCash: number | null } };

export type CheckRefundIsAvailableFromO24QueryVariables = Exact<{
  params: LegalPartyAndOperationId;
}>;


export type CheckRefundIsAvailableFromO24Query = { __typename?: 'Query', checkRefundIsAvailableFromO24: { __typename?: 'RefundIsAvailableResponse', availableRefundAmount: number, maskedAccount: string, recipientName: string } };

export type ConvertAmountQueryVariables = Exact<{
  convertAmountRequest: ConvertAmountRequest;
}>;


export type ConvertAmountQuery = { __typename?: 'Query', convertAmount: { __typename?: 'ConvertedAmountResponse', operationRate: number, operationCurrency: string, debitAmount: number, debitCurrency: string | null, creditAmount: number, creditCurrency: string | null, debitRate: string | null } };

export type GetAccountReqByIdQueryVariables = Exact<{
  accountId: Scalars['Long']['input'];
}>;


export type GetAccountReqByIdQuery = { __typename?: 'Query', getAccountById: { __typename?: 'AccountDto', account: string, id: number, departmentId: number, contractNumber: string, currency: { __typename?: 'CurrencyDto', isoNum: string } } };

export type FindAllCardReqsByAccountIdQueryVariables = Exact<{
  accountId: Scalars['Long']['input'];
  cardStatuses: Array<AccountStatus> | AccountStatus;
}>;


export type FindAllCardReqsByAccountIdQuery = { __typename?: 'Query', findAllCardsByAccountId: { __typename?: 'CardAccountData', account: { __typename?: 'AccountDto', account: string, departmentId: number, id: number, currency: { __typename?: 'CurrencyDto', isoNum: string } } } };

export type GetRequisitesByCurrencyQueryVariables = Exact<{
  currencyNumber: Scalars['String']['input'];
  departmentCode: Scalars['Int']['input'];
  accountId: Scalars['Long']['input'];
}>;


export type GetRequisitesByCurrencyQuery = { __typename?: 'Query', getRequisitesByCurrency: { __typename?: 'DirectoryResponse', clientAddress: string | null, department: { __typename?: 'Department', name: string | null, address: string | null, bic: number | null, accountNumber: string | null }, requisites: Array<{ __typename?: 'Requisite', comment: string | null, recipientBank: { __typename?: 'Bank', swiftCode: string | null, address: string | null, name: string | null } | null, intermediaryBank: { __typename?: 'Bank', swiftCode: string | null, address: string | null, name: string | null } | null, recipientBankPayload: Array<{ __typename?: 'Payload', value: string | null, type: BankPayloadType | null } | null>, intermediaryBankPayload: Array<{ __typename?: 'Payload', type: BankPayloadType | null, value: string | null } | null>, currency: { __typename?: 'Currency', code: string | null } | null, correspondentBankPayload: Array<{ __typename?: 'CorrespondentBankPayload', value: string | null, type: string | null } | null> | null, correspondentBank: { __typename?: 'CorrespondentBankDto', swiftCode: string | null, name: string | null, address: string | null } | null }> } | null };

export type GetCardAccountsFromEfrQueryVariables = Exact<{
  getCardAccountFromEfr: GetCardAccountFromEfrDto;
  legalPartyId: Scalars['Long']['input'];
}>;


export type GetCardAccountsFromEfrQuery = { __typename?: 'Query', getCardAccountsFromEfr: Array<{ __typename?: 'CardAccountFromEfrDto', account: string, cards: Array<{ __typename?: 'CardFromEfrDto', partyId: number | null, cardNum: string, state: string }> }> };

export const AvailableBalanceDetailsFragmentDoc = gql`
    fragment AvailableBalanceDetails on AvailableBalanceDetailsDto {
  account
  actualBalance
  availableBalance
  currency {
    isoCode
    isoNum
  }
  signing {
    totalAmount
    paymentCount
  }
  processing {
    totalAmount
    paymentCount
  }
}
    `;
export const AccountCurrencyAmountFragmentDoc = gql`
    fragment AccountCurrencyAmount on AccountCurrencyAmountDto {
  currency {
    isoCode
    isoNum
  }
  account
  amount
}
    `;
export const CurrencyForAccountFragmentDoc = gql`
    fragment CurrencyForAccount on CurrencyDto {
  isoCode
  isoNum
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on AccountDto {
  id
  bic
  type
  status
  partyId
  account
  balance
  plannedBalance
  interestRate
  accountName
  closeDate
  isVisible
  contractNumber
  departmentId
  accountClassification
  currency {
    isoCode
    isoNum
  }
}
    `;
export const TransferAccountFragmentDoc = gql`
    fragment TransferAccount on TransferAccountDto {
  id
  account
  accountName
  bic
  currency {
    isoCode
    isoNum
  }
}
    `;
export const BaseAccountFragmentDoc = gql`
    fragment BaseAccount on BaseAccountDto {
  id
  bic
  partyId
  account
  balance
  accountName
  departmentId
  type
  accountClassification
  currency {
    isoCode
    isoNum
  }
}
    `;
export const AccountWithPermissionListFragmentDoc = gql`
    fragment AccountWithPermissionList on AccountWithPermissionList {
  account {
    id
    bic
    type
    status
    partyId
    account
    balance
    plannedBalance
    interestRate
    accountName
    closeDate
    isVisible
    contractNumber
    currency {
      isoCode
      isoNum
    }
  }
  permissions
  availablePermissions
}
    `;
export const CardWithPermissionListFragmentDoc = gql`
    fragment CardWithPermissionList on CardWithPermissionList {
  card {
    id
    cardNum
    rbsNumber
    cardHolderName
    expiryDate
    title
    account {
      id
      account
      bic
    }
    status
    paymentSystem
  }
  permissions
  availablePermissions
}
    `;
export const AccountWithPermissionListForPaymentFragmentDoc = gql`
    fragment AccountWithPermissionListForPayment on AccountWithPermissionList {
  account {
    id
    bic
    type
    status
    partyId
    account
    balance
    plannedBalance
    interestRate
    accountName
    closeDate
    isVisible
    contractNumber
    departmentId
    accountClassification
    currency {
      isoCode
      isoNum
    }
  }
  permissions
  availablePermissions
  cards {
    ...CardWithPermissionList
  }
}
    ${CardWithPermissionListFragmentDoc}`;
export const ContractTransactionsFragmentDoc = gql`
    fragment ContractTransactions on ContractTransactionsDTO {
  baseAmount
  transactionAmount
  transactionCurrency
  settlementAmount
  settlementCurrency
  transactionDetails
  transactionDate
  commissionAmount
  commissionCurrency
}
    `;
export const CardDataForDetailFragmentDoc = gql`
    fragment CardDataForDetail on CardAccountData {
  account {
    account
    id
  }
  cards {
    card {
      id
      cardNum
      paymentSystem
      cardHolderName
    }
    permissions
  }
  availableAmount
  multiBalance {
    currency
    amount
  }
}
    `;
export const CardLimitInfoFragmentDoc = gql`
    fragment CardLimitInfo on CardLimitDto {
  limitType
  maxAmount
  maxNumber
  availableAmount
  availableNumber
  usedAmount
  usedNumber
  startDate
  endDate
}
    `;
export const AccountsIdFragmentDoc = gql`
    fragment AccountsId on AccountDto {
  id
}
    `;
export const BalanceFragmentDoc = gql`
    fragment Balance on BalanceDto {
  amount
  currency
}
    `;
export const CardFragmentDoc = gql`
    fragment Card on CardDto {
  id
  cardNum
  rbsNumber
  cardHolderName
  expiryDate
  title
  account {
    id
    account
    bic
  }
  status
  paymentSystem
}
    `;
export const CardDataFragmentDoc = gql`
    fragment CardData on CardAccountData {
  availableAmount
  multiBalance {
    ...Balance
  }
  cards {
    card {
      ...Card
    }
    permissions
  }
}
    ${BalanceFragmentDoc}
${CardFragmentDoc}`;
export const AccountWithPermissionListForPaymentCardFragmentDoc = gql`
    fragment AccountWithPermissionListForPaymentCard on AccountWithPermissionList {
  account {
    id
    account
  }
  permissions
  availablePermissions
  cards {
    ...CardWithPermissionList
  }
}
    ${CardWithPermissionListFragmentDoc}`;
export const AccountForQrFragmentDoc = gql`
    fragment AccountForQR on AccountWithPermissionList {
  account {
    account
    type
    accountClassification
  }
  cards {
    card {
      title
      account {
        account
        accountClassification
      }
      cardNum
      cardHolderName
    }
  }
}
    `;
export const ElQrFragmentDoc = gql`
    fragment ElQr on QrDto {
  elQrUri
  elQrUrl
}
    `;
export const BalanceInfoByPeriodFragmentDoc = gql`
    fragment BalanceInfoByPeriod on BalanceInfoByPeriod {
  startBalances {
    currency
    amount
  }
  endBalances {
    currency
    amount
  }
}
    `;
export const NptFragmentDoc = gql`
    fragment Npt on NptDto {
  pdfLink
  pdfNoticeLink
}
    `;
export const ConvertedAmountResponseFragmentDoc = gql`
    fragment ConvertedAmountResponse on ConvertedAmountResponse {
  operationRate
  operationCurrency
  debitAmount
  debitCurrency
  creditAmount
  creditCurrency
  debitRate
}
    `;
export const RefundQrOperationDetailFragmentDoc = gql`
    fragment RefundQrOperationDetail on RefundedQrOperationDetail {
  createdDateTime
  operationStatus
  purpose
  operationType
  stanOfBaseOperation
  refundedOperationStan
  cardHolderName
  cardNum
  amountOfBaseOperation
  refundedAmount
  feeAmountOfBaseOperation
  feePercentOfBaseOperation
  qrTransactionId
  salePointAddress
  salePointCash
}
    `;
export const QrRefundIsAvailableResponseFragmentDoc = gql`
    fragment QrRefundIsAvailableResponse on RefundIsAvailableResponse {
  availableRefundAmount
  maskedAccount
  recipientName
}
    `;
export const AccountReqFragmentDoc = gql`
    fragment AccountReq on AccountDto {
  account
  id
  departmentId
  contractNumber
  currency {
    isoNum
  }
}
    `;
export const CardAccountReqFragmentDoc = gql`
    fragment CardAccountReq on CardAccountData {
  account {
    account
    departmentId
    id
    currency {
      isoNum
    }
  }
}
    `;
export const DirectoryReqFragmentDoc = gql`
    fragment DirectoryReq on DirectoryResponse {
  clientAddress
  department {
    name
    address
    bic
    accountNumber
  }
  requisites {
    comment
    recipientBank {
      swiftCode
      address
      name
    }
    intermediaryBank {
      swiftCode
      address
      name
    }
    recipientBankPayload {
      value
      type
    }
    intermediaryBankPayload {
      type
      value
    }
    currency {
      code
    }
    correspondentBankPayload {
      value
      type
    }
    correspondentBank {
      swiftCode
      name
      address
    }
  }
}
    `;
export const CardFromEfrFragmentDoc = gql`
    fragment CardFromEfr on CardFromEfrDto {
  partyId
  cardNum
  state
}
    `;
export const CardAccountFromEfrFragmentDoc = gql`
    fragment CardAccountFromEfr on CardAccountFromEfrDto {
  account
  cards {
    ...CardFromEfr
  }
}
    ${CardFromEfrFragmentDoc}`;
export const AccountMainFragmentDoc = gql`
    fragment AccountMain on AccountDto {
  id
  status
  account
  balance
  isVisible
  contractNumber
  accountClassification
  currency {
    isoCode
  }
}
    `;
export const GetAccountBalanceDocument = gql`
    query getAccountBalance($availableBalanceRequestInput: AvailableBalanceRequestInput!) {
  getAccountBalance(availableBalanceRequestInput: $availableBalanceRequestInput) {
    ...AccountCurrencyAmount
  }
}
    ${AccountCurrencyAmountFragmentDoc}`;
export const GetFullInfoAboutAvailableBalanceDocument = gql`
    query getFullInfoAboutAvailableBalance($availableBalanceRequestInput: AvailableBalanceRequestInput!) {
  getFullInfoAboutAvailableBalance(
    availableBalanceRequestInput: $availableBalanceRequestInput
  ) {
    ...AvailableBalanceDetails
  }
}
    ${AvailableBalanceDetailsFragmentDoc}`;
export const UpdatePermissionsDocument = gql`
    mutation updatePermissions($changePermission: ChangePermissionDto!) {
  updatePermissions(changePermission: $changePermission)
}
    `;
export const UpdatePermissionsCardDocument = gql`
    mutation updatePermissionsCard($changePermission: ChangeCardPermissionDto!) {
  updatePermissionsCard(changePermission: $changePermission)
}
    `;
export const UpdateVisibleDocument = gql`
    mutation updateVisible($accountId: Long!, $isVisible: Boolean!) {
  updateVisible(accountId: $accountId, isVisible: $isVisible)
}
    `;
export const SetCardStatusDocument = gql`
    mutation setCardStatus($cardId: Long!, $status: CardStatusesFromPc!, $reason: String!) {
  setCardStatus(cardId: $cardId, status: $status, reason: $reason)
}
    `;
export const SetInternetTransactionsAvailabilityDocument = gql`
    mutation setInternetTransactionsAvailability($cardId: Long!, $setInternetTransactionInput: SetInternetTransactionInput!) {
  setInternetTransactionsAvailability(
    cardId: $cardId
    setInternetTransactionInput: $setInternetTransactionInput
  )
}
    `;
export const SetCardLimitDocument = gql`
    mutation setCardLimit($cardId: Long!, $setSetLimitInput: SetLimitInput!) {
  setCardLimit(cardId: $cardId, setLimitInput: $setSetLimitInput)
}
    `;
export const UnlockCardDocument = gql`
    mutation unlockCard($cardId: Long!, $reason: String!) {
  unlockCard(cardId: $cardId, reason: $reason)
}
    `;
export const UpdateCardTitleDocument = gql`
    mutation updateCardTitle($cardId: Long!, $cardTitle: String!) {
  updateCardTitle(cardId: $cardId, cardTitle: $cardTitle)
}
    `;
export const FindAllAccountsByPartyIdWithAclDocument = gql`
    query findAllAccountsByPartyIdWithAcl($filterInput: AccountFilterInput!) {
  findAllAccountsByPartyIdWithAcl(filterInput: $filterInput) {
    ...Account
  }
}
    ${AccountFragmentDoc}`;
export const FindAllAccountsByPartyIdWithAclMainDocument = gql`
    query findAllAccountsByPartyIdWithAclMain($filterInput: AccountFilterInput!) {
  findAllAccountsByPartyIdWithAcl(filterInput: $filterInput) {
    ...AccountMain
  }
}
    ${AccountMainFragmentDoc}`;
export const FindAllAccountsByFilterWithPermissionsDocument = gql`
    query findAllAccountsByFilterWithPermissions($filterInput: AccountFilterInput!, $permissions: [PaymentType!]!) {
  findAllAccountsByFilterWithPermissions(
    filterInput: $filterInput
    permissions: $permissions
  ) {
    ...AccountWithPermissionListForPayment
  }
}
    ${AccountWithPermissionListForPaymentFragmentDoc}`;
export const GetAccessControlListForUserDocument = gql`
    query getAccessControlListForUser($filter: AccountWithPermissionFilterInput!) {
  getAccessControlListForUser(filter: $filter) {
    ...AccountWithPermissionListForPayment
  }
}
    ${AccountWithPermissionListForPaymentFragmentDoc}`;
export const GetAccessControlListForUserCardDocument = gql`
    query getAccessControlListForUserCard($filter: AccountWithPermissionFilterInput!) {
  getAccessControlListForUser(filter: $filter) {
    ...AccountWithPermissionListForPaymentCard
  }
}
    ${AccountWithPermissionListForPaymentCardFragmentDoc}`;
export const GetAccountByIdDocument = gql`
    query getAccountById($accountId: Long!) {
  getAccountById(accountId: $accountId) {
    ...Account
  }
}
    ${AccountFragmentDoc}`;
export const FindByAccountAndCurrencyDocument = gql`
    query findByAccountAndCurrency($account: String!, $currencyNum: String!) {
  findByAccountAndCurrency(account: $account, currencyNum: $currencyNum) {
    ...TransferAccount
  }
}
    ${TransferAccountFragmentDoc}`;
export const FindAllByAccountDocument = gql`
    query findAllByAccount($account: String!) {
  findAllByAccount(account: $account) {
    ...TransferAccount
  }
}
    ${TransferAccountFragmentDoc}`;
export const FindAllByPartyIdBaseRkoAccountInfoDocument = gql`
    query findAllByPartyIdBaseRkoAccountInfo($partyId: Long!) {
  findAllByPartyIdBaseRkoAccountInfo(partyId: $partyId) {
    ...BaseAccount
  }
}
    ${BaseAccountFragmentDoc}`;
export const FindAllByPartyIdBaseCardAccountInfoDocument = gql`
    query findAllByPartyIdBaseCardAccountInfo($partyId: Long!) {
  findAllByPartyIdBaseCardAccountInfo(partyId: $partyId) {
    ...BaseAccount
  }
}
    ${BaseAccountFragmentDoc}`;
export const FindAllByFilterDocument = gql`
    query findAllByFilter($filterInput: AccountFilterInput!) {
  findAllByFilter(filterInput: $filterInput) {
    ...Account
  }
}
    ${AccountFragmentDoc}`;
export const GetAccountsWithPermissionsAndBaseDocument = gql`
    query getAccountsWithPermissionsAndBase($filterInput: AccountFilterInput!, $permissions: [PaymentType!]!, $partyId: Long!) {
  findAllAccountsByFilterWithPermissions(
    filterInput: $filterInput
    permissions: $permissions
  ) {
    ...AccountWithPermissionListForPayment
  }
  findAllByPartyIdBaseRkoAccountInfo(partyId: $partyId) {
    ...BaseAccount
  }
}
    ${AccountWithPermissionListForPaymentFragmentDoc}
${BaseAccountFragmentDoc}`;
export const GetCardTransferToBusinessDocument = gql`
    query getCardTransferToBusiness($filterInput: AccountFilterInput!, $permissions: [PaymentType!]!, $cardFilterInput: CardFilterInput!) {
  findAllAccountsByFilterWithPermissions(
    filterInput: $filterInput
    permissions: $permissions
  ) {
    ...AccountWithPermissionListForPayment
  }
  findAllCardsByFilter(filterInput: $cardFilterInput) {
    ...CardData
  }
}
    ${AccountWithPermissionListForPaymentFragmentDoc}
${CardDataFragmentDoc}`;
export const GetCardTransferToRKoDocument = gql`
    query getCardTransferToRKo($cardFilterInput: CardFilterInput!, $partyId: Long!) {
  findAllCardsByFilter(filterInput: $cardFilterInput) {
    ...CardData
  }
  findAllByPartyIdBaseRkoAccountInfo(partyId: $partyId) {
    ...BaseAccount
  }
}
    ${CardDataFragmentDoc}
${BaseAccountFragmentDoc}`;
export const GetSwiftAccountsDocument = gql`
    query getSwiftAccounts($filterInput: AccountFilterInput!, $accountPermissions: [PaymentType!]!, $commissionAccountPermissions: [PaymentType!]!) {
  accounts: findAllAccountsByFilterWithPermissions(
    filterInput: $filterInput
    permissions: $accountPermissions
  ) {
    ...AccountWithPermissionListForPayment
  }
  commissionAccounts: findAllAccountsByFilterWithPermissions(
    filterInput: $filterInput
    permissions: $commissionAccountPermissions
  ) {
    ...AccountWithPermissionListForPayment
  }
}
    ${AccountWithPermissionListForPaymentFragmentDoc}`;
export const GetRkoAccountsAndCardsDocument = gql`
    query getRkoAccountsAndCards($accountFilterInput: AccountFilterInput!, $permissions: [PaymentType!]!, $cardFilterInput: CardFilterInput!) {
  findAllAccountsByFilterWithPermissions(
    filterInput: $accountFilterInput
    permissions: $permissions
  ) {
    ...AccountWithPermissionListForPayment
  }
  findAllCardsByFilter(filterInput: $cardFilterInput) {
    ...CardData
  }
}
    ${AccountWithPermissionListForPaymentFragmentDoc}
${CardDataFragmentDoc}`;
export const FindAllCardsByFilterDocument = gql`
    query findAllCardsByFilter($filterInput: CardFilterInput!) {
  findAllCardsByFilter(filterInput: $filterInput) {
    ...CardData
  }
}
    ${CardDataFragmentDoc}`;
export const FindAllAccountsByPartyIdWithAclIdDocument = gql`
    query findAllAccountsByPartyIdWithAclId($filterInput: AccountFilterInput!) {
  findAllAccountsByPartyIdWithAcl(filterInput: $filterInput) {
    ...AccountsId
  }
}
    ${AccountsIdFragmentDoc}`;
export const FindAllCardsDetailByAccountIdDocument = gql`
    query findAllCardsDetailByAccountId($accountId: Long!, $cardStatuses: [AccountStatus!]!) {
  findAllCardsByAccountId(accountId: $accountId, cardStatuses: $cardStatuses) {
    ...CardDataForDetail
  }
}
    ${CardDataForDetailFragmentDoc}`;
export const FindAllCardsByAccountIdDocument = gql`
    query findAllCardsByAccountId($accountId: Long!, $cardStatuses: [AccountStatus!]!) {
  findAllCardsByAccountId(accountId: $accountId, cardStatuses: $cardStatuses) {
    ...CardData
  }
}
    ${CardDataFragmentDoc}`;
export const GetOperationListDocument = gql`
    query getOperationList($accountId: Long!, $startDate: Date!, $endDate: Date!) {
  getOperationList(
    accountId: $accountId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...ContractTransactions
  }
}
    ${ContractTransactionsFragmentDoc}`;
export const GetAvailableStatusesForCardDocument = gql`
    query getAvailableStatusesForCard($cardId: Long!) {
  getAvailableStatusesForCard(cardId: $cardId)
}
    `;
export const GetInternetTransactionsAvailabilityDocument = gql`
    query getInternetTransactionsAvailability($cardId: Long!) {
  getInternetTransactionsAvailability(cardId: $cardId)
}
    `;
export const FindAllAccountByFilterForQrDocument = gql`
    query findAllAccountByFilterForQr($filterInput: AccountFilterInput!, $permissions: [PaymentType!]!) {
  findAllAccountsByFilterWithPermissions(
    filterInput: $filterInput
    permissions: $permissions
  ) {
    ...AccountForQR
  }
}
    ${AccountForQrFragmentDoc}`;
export const GenerateElQrDocument = gql`
    query generateElQr($generateQrInput: GenerateQrInput!) {
  generateElQr(generateQrInput: $generateQrInput) {
    ...ElQr
  }
}
    ${ElQrFragmentDoc}`;
export const GetCardLimitInfoDocument = gql`
    query getCardLimitInfo($cardId: Long!) {
  getCardLimitInfo(cardId: $cardId) {
    ...CardLimitInfo
  }
}
    ${CardLimitInfoFragmentDoc}`;
export const GetNaturalPersonByPhoneOrCardDocument = gql`
    query getNaturalPersonByPhoneOrCard($naturalPersonCardAccountInput: NaturalPersonCardAccountInput!) {
  getNaturalPersonCards(
    naturalPersonCardAccountInput: $naturalPersonCardAccountInput
  ) {
    shortName
  }
}
    `;
export const GetAllAccountsForSalePointDocument = gql`
    query getAllAccountsForSalePoint($legalPartyId: Long!) {
  getAllAccountsForSalePoint(legalPartyId: $legalPartyId) {
    ...BaseAccount
  }
}
    ${BaseAccountFragmentDoc}`;
export const GetAccountBySalePointCodeDocument = gql`
    query getAccountBySalePointCode($salePointQr: SalePointAccount!) {
  getAccountBySalePointCode(salePointQr: $salePointQr) {
    ...BaseAccount
  }
}
    ${BaseAccountFragmentDoc}`;
export const GetBalanceInfoByPeriodDocument = gql`
    query getBalanceInfoByPeriod($accountId: Long!, $startDate: Date!, $endDate: Date!) {
  getBalanceInfoByPeriod(
    accountId: $accountId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...BalanceInfoByPeriod
  }
}
    ${BalanceInfoByPeriodFragmentDoc}`;
export const GetNptByLegalPartyIdDocument = gql`
    query getNptByLegalPartyId($legalPartyId: Long!) {
  getNptByLegalPartyId(legalPartyId: $legalPartyId) {
    ...Npt
  }
}
    ${NptFragmentDoc}`;
export const GetRefundedQrOperationInfoDocument = gql`
    query getRefundedQrOperationInfo($baseOperationId: String!, $legalPartyId: Long!) {
  getRefundedQrOperationInfo(
    baseOperationId: $baseOperationId
    legalPartyId: $legalPartyId
  ) {
    ...RefundQrOperationDetail
  }
}
    ${RefundQrOperationDetailFragmentDoc}`;
export const CheckRefundIsAvailableFromO24Document = gql`
    query checkRefundIsAvailableFromO24($params: LegalPartyAndOperationId!) {
  checkRefundIsAvailableFromO24(params: $params) {
    ...QrRefundIsAvailableResponse
  }
}
    ${QrRefundIsAvailableResponseFragmentDoc}`;
export const ConvertAmountDocument = gql`
    query convertAmount($convertAmountRequest: ConvertAmountRequest!) {
  convertAmount(convertAmountRequest: $convertAmountRequest) {
    ...ConvertedAmountResponse
  }
}
    ${ConvertedAmountResponseFragmentDoc}`;
export const GetAccountReqByIdDocument = gql`
    query getAccountReqById($accountId: Long!) {
  getAccountById(accountId: $accountId) {
    ...AccountReq
  }
}
    ${AccountReqFragmentDoc}`;
export const FindAllCardReqsByAccountIdDocument = gql`
    query findAllCardReqsByAccountId($accountId: Long!, $cardStatuses: [AccountStatus!]!) {
  findAllCardsByAccountId(accountId: $accountId, cardStatuses: $cardStatuses) {
    ...CardAccountReq
  }
}
    ${CardAccountReqFragmentDoc}`;
export const GetRequisitesByCurrencyDocument = gql`
    query getRequisitesByCurrency($currencyNumber: String!, $departmentCode: Int!, $accountId: Long!) {
  getRequisitesByCurrency(
    accountId: $accountId
    currencyNumber: $currencyNumber
    departmentCode: $departmentCode
  ) {
    ...DirectoryReq
  }
}
    ${DirectoryReqFragmentDoc}`;
export const GetCardAccountsFromEfrDocument = gql`
    query getCardAccountsFromEfr($getCardAccountFromEfr: GetCardAccountFromEfrDto!, $legalPartyId: Long!) {
  getCardAccountsFromEfr(
    getCardAccountFromEfr: $getCardAccountFromEfr
    legalPartyId: $legalPartyId
  ) {
    ...CardAccountFromEfr
  }
}
    ${CardAccountFromEfrFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getAccountBalance(variables: GetAccountBalanceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccountBalanceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccountBalanceQuery>(GetAccountBalanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccountBalance', 'query', variables);
    },
    getFullInfoAboutAvailableBalance(variables: GetFullInfoAboutAvailableBalanceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFullInfoAboutAvailableBalanceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFullInfoAboutAvailableBalanceQuery>(GetFullInfoAboutAvailableBalanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFullInfoAboutAvailableBalance', 'query', variables);
    },
    updatePermissions(variables: UpdatePermissionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePermissionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePermissionsMutation>(UpdatePermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePermissions', 'mutation', variables);
    },
    updatePermissionsCard(variables: UpdatePermissionsCardMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePermissionsCardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePermissionsCardMutation>(UpdatePermissionsCardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePermissionsCard', 'mutation', variables);
    },
    updateVisible(variables: UpdateVisibleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVisibleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVisibleMutation>(UpdateVisibleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVisible', 'mutation', variables);
    },
    setCardStatus(variables: SetCardStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetCardStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetCardStatusMutation>(SetCardStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setCardStatus', 'mutation', variables);
    },
    setInternetTransactionsAvailability(variables: SetInternetTransactionsAvailabilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetInternetTransactionsAvailabilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetInternetTransactionsAvailabilityMutation>(SetInternetTransactionsAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setInternetTransactionsAvailability', 'mutation', variables);
    },
    setCardLimit(variables: SetCardLimitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetCardLimitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetCardLimitMutation>(SetCardLimitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setCardLimit', 'mutation', variables);
    },
    unlockCard(variables: UnlockCardMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnlockCardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnlockCardMutation>(UnlockCardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unlockCard', 'mutation', variables);
    },
    updateCardTitle(variables: UpdateCardTitleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCardTitleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCardTitleMutation>(UpdateCardTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCardTitle', 'mutation', variables);
    },
    findAllAccountsByPartyIdWithAcl(variables: FindAllAccountsByPartyIdWithAclQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllAccountsByPartyIdWithAclQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllAccountsByPartyIdWithAclQuery>(FindAllAccountsByPartyIdWithAclDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllAccountsByPartyIdWithAcl', 'query', variables);
    },
    findAllAccountsByPartyIdWithAclMain(variables: FindAllAccountsByPartyIdWithAclMainQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllAccountsByPartyIdWithAclMainQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllAccountsByPartyIdWithAclMainQuery>(FindAllAccountsByPartyIdWithAclMainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllAccountsByPartyIdWithAclMain', 'query', variables);
    },
    findAllAccountsByFilterWithPermissions(variables: FindAllAccountsByFilterWithPermissionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllAccountsByFilterWithPermissionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllAccountsByFilterWithPermissionsQuery>(FindAllAccountsByFilterWithPermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllAccountsByFilterWithPermissions', 'query', variables);
    },
    getAccessControlListForUser(variables: GetAccessControlListForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccessControlListForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccessControlListForUserQuery>(GetAccessControlListForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccessControlListForUser', 'query', variables);
    },
    getAccessControlListForUserCard(variables: GetAccessControlListForUserCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccessControlListForUserCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccessControlListForUserCardQuery>(GetAccessControlListForUserCardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccessControlListForUserCard', 'query', variables);
    },
    getAccountById(variables: GetAccountByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccountByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccountByIdQuery>(GetAccountByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccountById', 'query', variables);
    },
    findByAccountAndCurrency(variables: FindByAccountAndCurrencyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindByAccountAndCurrencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindByAccountAndCurrencyQuery>(FindByAccountAndCurrencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findByAccountAndCurrency', 'query', variables);
    },
    findAllByAccount(variables: FindAllByAccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllByAccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllByAccountQuery>(FindAllByAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllByAccount', 'query', variables);
    },
    findAllByPartyIdBaseRkoAccountInfo(variables: FindAllByPartyIdBaseRkoAccountInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllByPartyIdBaseRkoAccountInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllByPartyIdBaseRkoAccountInfoQuery>(FindAllByPartyIdBaseRkoAccountInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllByPartyIdBaseRkoAccountInfo', 'query', variables);
    },
    findAllByPartyIdBaseCardAccountInfo(variables: FindAllByPartyIdBaseCardAccountInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllByPartyIdBaseCardAccountInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllByPartyIdBaseCardAccountInfoQuery>(FindAllByPartyIdBaseCardAccountInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllByPartyIdBaseCardAccountInfo', 'query', variables);
    },
    findAllByFilter(variables: FindAllByFilterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllByFilterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllByFilterQuery>(FindAllByFilterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllByFilter', 'query', variables);
    },
    getAccountsWithPermissionsAndBase(variables: GetAccountsWithPermissionsAndBaseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccountsWithPermissionsAndBaseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccountsWithPermissionsAndBaseQuery>(GetAccountsWithPermissionsAndBaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccountsWithPermissionsAndBase', 'query', variables);
    },
    getCardTransferToBusiness(variables: GetCardTransferToBusinessQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCardTransferToBusinessQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCardTransferToBusinessQuery>(GetCardTransferToBusinessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCardTransferToBusiness', 'query', variables);
    },
    getCardTransferToRKo(variables: GetCardTransferToRKoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCardTransferToRKoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCardTransferToRKoQuery>(GetCardTransferToRKoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCardTransferToRKo', 'query', variables);
    },
    getSwiftAccounts(variables: GetSwiftAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSwiftAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSwiftAccountsQuery>(GetSwiftAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSwiftAccounts', 'query', variables);
    },
    getRkoAccountsAndCards(variables: GetRkoAccountsAndCardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRkoAccountsAndCardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRkoAccountsAndCardsQuery>(GetRkoAccountsAndCardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRkoAccountsAndCards', 'query', variables);
    },
    findAllCardsByFilter(variables: FindAllCardsByFilterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllCardsByFilterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllCardsByFilterQuery>(FindAllCardsByFilterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllCardsByFilter', 'query', variables);
    },
    findAllAccountsByPartyIdWithAclId(variables: FindAllAccountsByPartyIdWithAclIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllAccountsByPartyIdWithAclIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllAccountsByPartyIdWithAclIdQuery>(FindAllAccountsByPartyIdWithAclIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllAccountsByPartyIdWithAclId', 'query', variables);
    },
    findAllCardsDetailByAccountId(variables: FindAllCardsDetailByAccountIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllCardsDetailByAccountIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllCardsDetailByAccountIdQuery>(FindAllCardsDetailByAccountIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllCardsDetailByAccountId', 'query', variables);
    },
    findAllCardsByAccountId(variables: FindAllCardsByAccountIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllCardsByAccountIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllCardsByAccountIdQuery>(FindAllCardsByAccountIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllCardsByAccountId', 'query', variables);
    },
    getOperationList(variables: GetOperationListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOperationListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOperationListQuery>(GetOperationListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOperationList', 'query', variables);
    },
    getAvailableStatusesForCard(variables: GetAvailableStatusesForCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAvailableStatusesForCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAvailableStatusesForCardQuery>(GetAvailableStatusesForCardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAvailableStatusesForCard', 'query', variables);
    },
    getInternetTransactionsAvailability(variables: GetInternetTransactionsAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetInternetTransactionsAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInternetTransactionsAvailabilityQuery>(GetInternetTransactionsAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInternetTransactionsAvailability', 'query', variables);
    },
    findAllAccountByFilterForQr(variables: FindAllAccountByFilterForQrQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllAccountByFilterForQrQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllAccountByFilterForQrQuery>(FindAllAccountByFilterForQrDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllAccountByFilterForQr', 'query', variables);
    },
    generateElQr(variables: GenerateElQrQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateElQrQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateElQrQuery>(GenerateElQrDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateElQr', 'query', variables);
    },
    getCardLimitInfo(variables: GetCardLimitInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCardLimitInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCardLimitInfoQuery>(GetCardLimitInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCardLimitInfo', 'query', variables);
    },
    getNaturalPersonByPhoneOrCard(variables: GetNaturalPersonByPhoneOrCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetNaturalPersonByPhoneOrCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNaturalPersonByPhoneOrCardQuery>(GetNaturalPersonByPhoneOrCardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getNaturalPersonByPhoneOrCard', 'query', variables);
    },
    getAllAccountsForSalePoint(variables: GetAllAccountsForSalePointQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllAccountsForSalePointQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllAccountsForSalePointQuery>(GetAllAccountsForSalePointDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllAccountsForSalePoint', 'query', variables);
    },
    getAccountBySalePointCode(variables: GetAccountBySalePointCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccountBySalePointCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccountBySalePointCodeQuery>(GetAccountBySalePointCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccountBySalePointCode', 'query', variables);
    },
    getBalanceInfoByPeriod(variables: GetBalanceInfoByPeriodQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBalanceInfoByPeriodQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBalanceInfoByPeriodQuery>(GetBalanceInfoByPeriodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBalanceInfoByPeriod', 'query', variables);
    },
    getNptByLegalPartyId(variables: GetNptByLegalPartyIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetNptByLegalPartyIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNptByLegalPartyIdQuery>(GetNptByLegalPartyIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getNptByLegalPartyId', 'query', variables);
    },
    getRefundedQrOperationInfo(variables: GetRefundedQrOperationInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRefundedQrOperationInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRefundedQrOperationInfoQuery>(GetRefundedQrOperationInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRefundedQrOperationInfo', 'query', variables);
    },
    checkRefundIsAvailableFromO24(variables: CheckRefundIsAvailableFromO24QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckRefundIsAvailableFromO24Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckRefundIsAvailableFromO24Query>(CheckRefundIsAvailableFromO24Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkRefundIsAvailableFromO24', 'query', variables);
    },
    convertAmount(variables: ConvertAmountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConvertAmountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConvertAmountQuery>(ConvertAmountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'convertAmount', 'query', variables);
    },
    getAccountReqById(variables: GetAccountReqByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAccountReqByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAccountReqByIdQuery>(GetAccountReqByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAccountReqById', 'query', variables);
    },
    findAllCardReqsByAccountId(variables: FindAllCardReqsByAccountIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllCardReqsByAccountIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllCardReqsByAccountIdQuery>(FindAllCardReqsByAccountIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllCardReqsByAccountId', 'query', variables);
    },
    getRequisitesByCurrency(variables: GetRequisitesByCurrencyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRequisitesByCurrencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRequisitesByCurrencyQuery>(GetRequisitesByCurrencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRequisitesByCurrency', 'query', variables);
    },
    getCardAccountsFromEfr(variables: GetCardAccountsFromEfrQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCardAccountsFromEfrQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCardAccountsFromEfrQuery>(GetCardAccountsFromEfrDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCardAccountsFromEfr', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;